import { createAsyncThunk } from "@reduxjs/toolkit";
import { Payment } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindPayment } from "../../payment/api/interface";

export const findPaymentExport = createAsyncThunk(
  "paymentExport/findPaymentExport",
  async (values: FindPayment, { rejectWithValue }) => {
    try {
      const response = await Payment.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);